import dayjs from "dayjs";

export const reduceText = (text = "", limitChars = 40) => {
	// Formating Text
	if(limitChars <= 0){
		limitChars = 40;
	}

	if (text == "") {
		return "---";
	}

	if (text.length > limitChars) {
		return text.substring(0, limitChars) + "...";
	}

	return text;
};

export const formatNumber = (value) => {
	// Asegurarnos de que value es un número y se formatee a dos decimales
	const number = Number(value).toFixed(4);
    
	// Dividir la parte entera y decimal del número
	const parts = number.split(".");
    
	// Formatear la parte entera con comas como separadores de miles
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
	// Unir la parte entera formateada con la parte decimal usando un punto
	return parts.join(".");
};

export const formatNumberOfCurrency = (number, currency) => {
	const formattedNumber = new Intl.NumberFormat("en", {
		style: "currency",
		currency,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(number);

	return formattedNumber;
};

export const formatShownDate = (dateString) => {
	const date = new Date(dateString);
	const options = {
		day: "2-digit",
		month: "short",
		year: "2-digit",
	};
	const newDate = date.toLocaleDateString("es-ES", options);
	return newDate;
};

export const formatShownHour = (dateString) => {
	const date = new Date(dateString);
	const options = {
		hour: "2-digit",
		minute: "2-digit",
	};
	const timeString = date.toLocaleTimeString("es-ES", options);
	return timeString;
};

export const formatShowStandarDate = (dateString) => {
	const date = new Date(dateString);

	if (isNaN(date.getTime())) {
		return null;
	}

	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	const year = date.getFullYear();

	return `${month}-${day}-${year}`;
};

export const convertTimestampToDate = (timestamp) => {
	if (!timestamp) return null;
	return dayjs(timestamp, "YYYY-MM-DD HH:mm:ss").toDate();
};